export const STATIC_SERVER_URL = process.env.STATIC_SERVER_URL || 'https://static.millesima.com';
export const CDN_SERVER_URL = `${STATIC_SERVER_URL}/s3`;
export const SVG_SERVER_URL = `${CDN_SERVER_URL}/next/svg`;
export const PICTO_SERVER_URL = `${CDN_SERVER_URL}/next/picto`;
export const ROUNDER_FLAG = `${SVG_SERVER_URL}/rounder-flag`;
export const BLOG_SERVER_URL = `${CDN_SERVER_URL}/attachements/editorial/`;
export const CUSTOMIZATION_SERVER_URL = `${CDN_SERVER_URL}/attachements/customization`;
export const CONTRIB_COMMON_IMAGES = `${CDN_SERVER_URL}/contrib/common/images`;
export const COMMON_IMAGES = `${CDN_SERVER_URL}/common`;
export const ESPOT_IMAGES_URL = `${CDN_SERVER_URL}/attachements/espot`;
export const PUSH_LISTING_ESPOT_IMAGES_URL = `${CDN_SERVER_URL}/attachements/espot/pushListing`;
export const PUSH_LISTING_ESPOT_IMAGES_WEBP = `${CDN_SERVER_URL}/attachements/webp/espot/pushListing`;
export const TOP_BANNER_ESPOT_IMAGES_URL = `${CDN_SERVER_URL}/attachements/espot/topBanner`;
export const PREMIUM_S3_URL = `${CDN_SERVER_URL}/premium`;
export const ICONS_SERVER_URL = `${CDN_SERVER_URL}/next/icons/24x24`;
export const PAYMENT_S3_URL = `${CDN_SERVER_URL}/common/picto/paiement`;

export const IMG_SIZE = {
  THUMB: 'thumb',
  FULL: 'full'
};

export const URL_SELECTORS = {
  IMAGE_NAME: '{IMAGE_NAME}',
  IMAGE_EXTENSION: '{EXTENSION}',
  SIZE: '{SIZE}',
};

const URL_MENU = `${CDN_SERVER_URL}/attachements/menu`;
const URL_MENU_ICON = `${URL_MENU}/02_Icon`;
const URL_HEADER = `${CDN_SERVER_URL}/attachements/header`;

export const URLS = {
  IMG: `${CDN_SERVER_URL}/attachements/h{0}px`,
  IMG_THUMB: `${CDN_SERVER_URL}/attachements/112x150px`,
  NOIMG: `${CDN_SERVER_URL}/attachements/neutre/no-image-icon_h{0}px.png`,
  STORE_FLAG: `${CDN_SERVER_URL}/attachements/flags/{0}.svg`,
  COUNTRY_FLAG: `${ROUNDER_FLAG}/producer/{0}.svg`,
  DEFAULT_WINEBOX_IMAGE: `${CDN_SERVER_URL}/attachements/neutre/panachee-2.png`,
  UTILS_MILLESIMA: `${CDN_SERVER_URL}/common/js/utilMillesima.js`,
  EC_IMAGE: `${CDN_SERVER_URL}/next/logo-ec-mini.png`,
  DEFAULT_OG_IMAGE: `${CDN_SERVER_URL}/attachements/fav-icn.jpg`,
  VIDEO_LISTING: `${CDN_SERVER_URL}/attachements/listing/img-video-listing`,
  BG_VIDEO_IMG: `${CDN_SERVER_URL}/next/bg-video.jpg`,
  BG_STORAGE: `${CONTRIB_COMMON_IMAGES}/bg-storage-desktop.jpg`,

  BOOTSTRAP: 'https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css',

  GOOGLE_FONTS: 'https://fonts.googleapis.com/css?family=Montserrat:wght@300;400;600;700&display=swap',
  ABTASTY: '//try.abtasty.com/640e684bcb18c1914471c7b885eb0103.js',
  JQUERY: 'https://code.jquery.com/jquery-3.4.1.min.js',
  GTM: 'https://www.googletagmanager.com/ns.html?id=GTM-MXK97HQ',
  HIPAY_SDK: 'https://libs.hipay.com/js/sdkjs.js',
  HIPAY_HOSTED_FIELDS: 'https://libs.hipay.com/hostedfields',
  HIPAY_FINGERPRINT: 'https://secure-gateway.hipay-tpp.com/gateway/toolbox/fingerprint',
  ADYEN_SDK: 'https://checkoutshopper-{0}.adyen.com/checkoutshopper/sdk/3.9.0/adyen.js',
  TRUSTEDSHOP_IMAGE: 'https://widgets.trustedshops.com/assets/images/trustmark_120x120.png',
  COOKIE_BANNER: '/cookie/scripttemplates/otSDKStub.js',

  BONUS_IMAGE: `${CDN_SERVER_URL}/attachements/bonus/${URL_SELECTORS.SIZE}/${URL_SELECTORS.IMAGE_NAME}.${URL_SELECTORS.IMAGE_EXTENSION}`,
  BONUS_VIDEO: `https://img.youtube.com/vi/${URL_SELECTORS.IMAGE_NAME}/1.jpg`,

  CALENDAR: `${URL_MENU_ICON}/Calendar.svg`,
  DECONNEXION: `${URL_MENU_ICON}/deconnexion.svg`,
  FLECHE: `${URL_MENU_ICON}/fleche.svg`,
  ICON_ARROW: `${URL_MENU_ICON}/icon-arrow.svg`,
  ICON_ARROW_NAV_DOWN: `${URL_MENU_ICON}/icon-arrow-nav-down.svg`,
  ICON_ARROW_NAV_LEFT: `${URL_MENU_ICON}/icon-arrow-nav-left.svg`,
  ICON_ARROW_NAV_RIGHT: `${URL_MENU_ICON}/icon-arrow-nav-right.svg`,
  ICON_ARROW_NAV_UP: `${URL_MENU_ICON}/icon-arrow-nav-up.svg`,
  ICON_BORDEAUX: `${URL_MENU_ICON}/icon-bordeaux.svg`,
  ICON_BOURGOGNE: `${URL_MENU_ICON}/icon-bourgogne.svg`,
  ICON_CHAMPAGNE: `${URL_MENU_ICON}/icon-champagne.svg`,
  ICON_CLOSE: `${URL_MENU_ICON}/icon-close.svg`,
  ICON_INFO_HELP: `${SVG_SERVER_URL}/info-help.svg`,
  ICON_NEWSLETTER: `${URL_MENU_ICON}/Icon-newsletter.svg`,
  ICON_RETRAIT_CHAIS: `${URL_MENU_ICON}/icon-retraitChais.svg`,
  ICON_SEARCH: `${URL_MENU_ICON}/icon-search.svg`,
  ICON_STOCK_CHAIS: `${URL_MENU_ICON}/icon-stockChais.svg`,
  RONDER_FLAG_FR: `${URL_MENU_ICON}/ronder-flag-fr.svg`,

  GRAPPE: `${URL_MENU}/Grappe.svg`,
  ICON_CAISSE_DECOUVERTE: `${URL_MENU}/icon-caisseDecouverte.svg`,
  ICON_EC: `${URL_MENU}/icon-EC.svg`,
  ICON_MEILLEUR_VENTE: `${URL_MENU}/icon-meilleurvente.svg`,
  ICON_NOTE: `${URL_MENU}/icon-note.svg`,
  ICON_ORIGINE: `${URL_MENU}/icon-origine.svg`,
  ICON_PRIMEUR: `${URL_MENU}/icon-primeur.svg`,
  ICON_PRIMEUR_2: `${URL_MENU}/icon-primeur-2.svg`,
  ICON_PROMO: `${URL_MENU}/icon-promo.svg`,

  ICON_SEARCH_WHITE: `${CDN_SERVER_URL}/next/svg/icon-search.svg`,

  ADMIN_BLACK: `${URL_HEADER}/admin-black.svg`,
  ADMIN_WHITE: `${URL_HEADER}/admin-white.svg`,
  MOBILE_BLACK: `${URL_HEADER}/mobile.svg`,
  MOBILE_WHITE: `${URL_HEADER}/mobile-white.svg`,
  LOCATION_BLACK: `${SVG_SERVER_URL}/location-pin.svg`,
  LOCATION_WHITE: `${SVG_SERVER_URL}/location-pin-white.svg`,

  CIRCLE_FLAG_FRANCE: `${ROUNDER_FLAG}/france.svg`,

  BACKGROUND_LISTING: `${CDN_SERVER_URL}/attachements/listing/background-listing.jpg`,
  BLACK_ICON_ADD: `${SVG_SERVER_URL}/add.svg`,
  WHITE_ICON_ADD: `${SVG_SERVER_URL}/add-white.svg`,
  ADD_SQUARE_SOLID: `${SVG_SERVER_URL}/add-square-solid.svg`,
  ADD_CIRCLE: `${SVG_SERVER_URL}/add-circle.svg`,
  ICON_MINUS: `${SVG_SERVER_URL}/minus.svg`,
  ORION_CLOSE_BLACK: `${SVG_SERVER_URL}/orion-close.svg`,
  ORION_CLOSE_WHITE: `${SVG_SERVER_URL}/orion-close_white.svg`,
  DELETE_CIRCLE_ICON_BLACK: `${SVG_SERVER_URL}/delete-circle.svg`,
  DELETE_CIRCLE_ICON_RED: `${SVG_SERVER_URL}/delete-circle-red.svg`,
  CHECKBOX_CONFIRM_CIRCLE_GREEN: `${SVG_SERVER_URL}/checkbox-confirm-circle-green.svg`,
  CHECKBOX_CONFIRM_CIRCLE_GREY: `${SVG_SERVER_URL}/checkbox-confirm-circle-grey.svg`,
  CHECKED_CIRCLE_ICON_BLACK: `${SVG_SERVER_URL}/checked-circle.svg`,
  CHECKED_CIRCLE_ICON_GREEN: `${SVG_SERVER_URL}/checked-circle-green.svg`,
  LOCK_PREMIUM: `${SVG_SERVER_URL}/lock-premium.svg`,
  LOCK_PREMIUM_DISABLE: `${SVG_SERVER_URL}/lock-premium_disable.svg`,
  LOCK_PREMIUM_WHITE: `${SVG_SERVER_URL}/lock-premium_white.svg`,
  LOCK_PREMIUM_OPEN: `${SVG_SERVER_URL}/lock-premium-open.svg`,
  LOCK_PREMIUM_OPEN_DISABLE: `${SVG_SERVER_URL}/lock-premium-open_disable.svg`,
  LOCK_PREMIUM_OPEN_WHITE: `${SVG_SERVER_URL}/lock-premium-open_white.svg`,
  ICON_USER: `${SVG_SERVER_URL}/user.svg`,
  ICON_USER_DISABLE: `${SVG_SERVER_URL}/user_disable.svg`,
  ICON_USER_WHITE: `${SVG_SERVER_URL}/user_white.svg`,
  LOCK_GREY: `${SVG_SERVER_URL}/lock-grey.svg`,
  LOCK_WHITE: `${SVG_SERVER_URL}/lock-white.svg`,
  DELIVERY_TRUCK_GREY: `${SVG_SERVER_URL}/delivery-truck-grey.svg`,
  DELIVERY_TRUCK_BLACK: `${SVG_SERVER_URL}/order_truck.svg`,
  DELIVERY_BOX_BLACK: `${SVG_SERVER_URL}/order-box.svg`,
  BADGE_NOTES: `${SVG_SERVER_URL}/badge_notes.svg`,
  FACEBOOK_ICON: `${SVG_SERVER_URL}/outline-facebook.svg`,
  INSTAGRAM_ICON: `${SVG_SERVER_URL}/outline-instagram.svg`,
  TWITTER_ICON: `${SVG_SERVER_URL}/outline-twitter.svg`,
  YOUTUBE_ICON: `${SVG_SERVER_URL}/outline-youtube.svg`,
  ICON_HOUSE: `${SVG_SERVER_URL}/house.svg`,
  ICON_DOWNLOAD: `${SVG_SERVER_URL}/download.svg`,
  ICON_CREDIT_CARD: `${SVG_SERVER_URL}/credit-card.svg`,
  ICON_PACKAGE_DELIVERED: `${SVG_SERVER_URL}/package-delivered.svg`,
  ICON_HEART: `${SVG_SERVER_URL}/heart.svg`,
  STAR_YELLOW: `${SVG_SERVER_URL}/star-yellow.svg`,
  ICON_HEART_FILL: `${SVG_SERVER_URL}/heart-fill.svg`,
  ICON_MAIL: `${SVG_SERVER_URL}/envelope.svg`,
  ICON_NEWS: `${SVG_SERVER_URL}/news.svg`,
  STORAGE_BOXES_GREEN: `${SVG_SERVER_URL}/stock-boxes-green.svg`,
  WARNING_ICON_BLACK: `${SVG_SERVER_URL}/priority-warning.svg`,
  WARNING_ICON_ORANGE: `${SVG_SERVER_URL}/priority-warning-highlight.svg`,
  EDIT_BLACK: `${SVG_SERVER_URL}/edit.svg`,
  RETAIL_BAG: `${SVG_SERVER_URL}/retail-bag.svg`,
  SOCIAL_GOOGLE: `${SVG_SERVER_URL}/social-google.svg`,
  SOCIAL_APPLE: `${SVG_SERVER_URL}/social-apple.svg`,
  ICON_LOCK: `${SVG_SERVER_URL}/lock.svg`,

  ICON_WISHLIST: `${SVG_SERVER_URL}/wishlist.svg`,
  ICON_ARROW_LEFT: `${SVG_SERVER_URL}/arrow-left.svg`,
  ICON_QUESTION_HELP: `${SVG_SERVER_URL}/question-help.svg`,
  AGRIBIO_ICON: `${SVG_SERVER_URL}/label_agribio.svg`,
  BIODYVIN_ICON: `${SVG_SERVER_URL}/label_biodyvin.svg`,
  DEMETER_ICON: `${SVG_SERVER_URL}/label_demeter.svg`,
  HVE_ICON: `${SVG_SERVER_URL}/label_HVE.svg`,
  BIO_CIRCLE_ICON: `${SVG_SERVER_URL}/logo_ab.svg`,
  HVE_CIRCLE_ICON: `${SVG_SERVER_URL}/logo_HVE.svg`,
  ICON_YOUTUBE_WHITE: `${SVG_SERVER_URL}/youtube_solid_white.svg`,
  ICON_YOUTUBE_BLACK: `${SVG_SERVER_URL}/youtube_solid.svg`,
  ICON_SMARTPHONE: `${SVG_SERVER_URL}/smartphone.svg`,
  ACT_AS: `${SVG_SERVER_URL}/act_as.svg`,
  LEAVE_ACT_AS: `${SVG_SERVER_URL}/export.svg`,
  ICON_VIEW: `${SVG_SERVER_URL}/view.svg`,
  ICON_HIDDEN: `${SVG_SERVER_URL}/hidden.svg`,
  ICON_LETTER_A: `${SVG_SERVER_URL}/letter_a.svg`,
  ICON_RIGHT_ALIGN_TEXT: `${SVG_SERVER_URL}/right-align-text.svg`,
  ICON_LEFT_ALIGN_TEXT: `${SVG_SERVER_URL}/left-align-text.svg`,
  ICON_CENTER_TEXT: `${SVG_SERVER_URL}/center-text.svg`,
  ICON_DELAYED_SHIPPING: `${SVG_SERVER_URL}/hourglass.svg`,
  ICON_BOTTLE_GREY: `${SVG_SERVER_URL}/bottle-grey.svg`,
  ICON_SHOPPING_CART_WHITE: `${SVG_SERVER_URL}/add-to-shopping-cart-white.svg`,

  OUT_OF_STOCK: `${SVG_SERVER_URL}/out-of-stock.svg`,

  // product CP attrbutes
  ICON_GRAPE: `${SVG_SERVER_URL}/grape.svg`,
  ICON_LOCATION_PIN: `${SVG_SERVER_URL}/location-pin.svg`,
  ICON_STAR_LINE: `${SVG_SERVER_URL}/star_line.svg`,
  ICON_WINE_GLASS: `${SVG_SERVER_URL}/wine-glass.svg`,

  NAV_DOWN: `${SVG_SERVER_URL}/angle-down.svg`,
  NAV_UP: `${SVG_SERVER_URL}/angle-up.svg`,
  NAV_RIGHT: `${SVG_SERVER_URL}/angle-right.svg`,
  NAV_LEFT: `${SVG_SERVER_URL}/angle-left.svg`,

  ARROW_LEFT: `${SVG_SERVER_URL}/arrow-left.svg`,
  ARROW_RIGHT_WHITE_OLD: `${SVG_SERVER_URL}/arrow-right-white.svg`,
  ARROW_LEFT_WHITE_OLD: `${SVG_SERVER_URL}/arrow-left-white.svg`,

  WB_IMG_V: `${CUSTOMIZATION_SERVER_URL}/500_CP_V_Desktop.png`,
  WB_CART_IMG: `${CUSTOMIZATION_SERVER_URL}/cp-woodbox.png`,

  ICON_MY_CELLAR: `${SVG_SERVER_URL}/my-cellar.svg`,
  ICON_FILTERS: `${SVG_SERVER_URL}/filter.svg`,

  CUSTOMER_LOYALTY: `${SVG_SERVER_URL}/loyalty-program.svg`,

  PRIMEUR_NOTIF: `${SVG_SERVER_URL}/notifications.svg`,
  PRIMEUR_NOTIF_WHITE: `${SVG_SERVER_URL}/notifications_white.svg`,
  PRIMEUR_SETTING: `${SVG_SERVER_URL}/setting.svg`,
  PRIMEUR_SEARCH: `${SVG_SERVER_URL}/search.svg`,
  ICON_CHECKMARK_GREEN: `${SVG_SERVER_URL}/checkmark-green.svg`,

  LOGO_RP_COLOR: `${SVG_SERVER_URL}/logo-rp-color.svg`,
  ICON_CHECKMARK_WHITE: `${SVG_SERVER_URL}/checkmark_white.svg`,
  ICON_MENU_BURGER_BLACK: `${SVG_SERVER_URL}/menu-burger.svg`,

  WINE_BOX_IMG: `${CONTRIB_COMMON_IMAGES}/cp-stockage.png`,

  EXPRO_ACCOUNT: `${SVG_SERVER_URL}/wine_barrel.svg`,
  TRUSTEDSHOP_BLACK: `${SVG_SERVER_URL}/trustedShop-logo-black.svg`,
  TRUSTEDSHOP_WHITE: `${SVG_SERVER_URL}/trustedShop-logo.svg`,
  LOADER_BLACK: `${SVG_SERVER_URL}/loader.svg`,

  // PAYMENT
  AMEX: `${PAYMENT_S3_URL}/AmericanExpess_color_mini.svg`,
  MASTERCARD: `${PAYMENT_S3_URL}/MasterCard_color_mini.svg`,
  VISA: `${PAYMENT_S3_URL}/Visa_color_mini.svg`,

  // icons 24x24
  ACCOUNT_WHITE: `${ICONS_SERVER_URL}/account-white.svg`,
  ACCOUNT_BLACK: `${ICONS_SERVER_URL}/account-black.svg`,
  ADD_BLACK: `${ICONS_SERVER_URL}/add-black.svg`,
  ADD_CIRCLE_BLACK: `${ICONS_SERVER_URL}/add-circle-black.svg`,
  ADD_WHITE: `${ICONS_SERVER_URL}/add-white.svg`,
  ANGLE_BOTTOM_BLACK: `${ICONS_SERVER_URL}/angle-bottom-black.svg`,
  ANGLE_BOTTOM_GREY: `${ICONS_SERVER_URL}/angle-bottom-grey.svg`,
  ANGLE_LEFT_BLACK: `${ICONS_SERVER_URL}/angle-left-black.svg`,
  ANGLE_RIGHT_BLACK: `${ICONS_SERVER_URL}/angle-right-black.svg`,
  ANGLE_RIGHT_WHITE: `${ICONS_SERVER_URL}/angle-right-white.svg`,
  ANGLE_TOP_BLACK: `${ICONS_SERVER_URL}/angle-top-black.svg`,
  ARROW_DOWN_BLACK: `${ICONS_SERVER_URL}/arrow-down-black.svg`,
  ARROW_DOWN_WHITE: `${ICONS_SERVER_URL}/arrow-down-white.svg`,
  ARROW_LEFT_BLACK: `${ICONS_SERVER_URL}/arrow-left-black.svg`,
  ARROW_LEFT_WHITE: `${ICONS_SERVER_URL}/arrow-left-white.svg`,
  ARROW_RIGHT_BLACK: `${ICONS_SERVER_URL}/arrow-right-black.svg`,
  ARROW_RIGHT_WHITE: `${ICONS_SERVER_URL}/arrow-right-white.svg`,
  ARROW_UP_BLACK: `${ICONS_SERVER_URL}/arrow-UP-black.svg`,
  ARROW_UP_WHITE: `${ICONS_SERVER_URL}/arrow-UP-white.svg`,
  CHECKED_CIRCLE_GREEN: `${ICONS_SERVER_URL}/checked-circle-green.svg`,
  CART_BLACK: `${ICONS_SERVER_URL}/cart-black.svg`,
  CART_WHITE: `${ICONS_SERVER_URL}/cart-white.svg`,
  CROSS_BLACK: `${ICONS_SERVER_URL}/cross-black.svg`,
  DELETE_CIRCLE_RED: `${ICONS_SERVER_URL}/delete-circle-red.svg`,
  EDIT_BLACK_24: `${ICONS_SERVER_URL}/edit-black.svg`,
  EYE_BLACK: `${ICONS_SERVER_URL}/eye-black.svg`,
  GALLERY: `${ICONS_SERVER_URL}/gallery-black.svg`,
  GLOBAL_WHITE: `${ICONS_SERVER_URL}/globe-white.svg`,
  ICON_MENU_BURGER_WHITE: `${ICONS_SERVER_URL}/menu-white.svg`,
  INFORMATION_BLACK: `${ICONS_SERVER_URL}/information-black.svg`,
  INFORMATION_BLUE: `${ICONS_SERVER_URL}/information-blue.svg`,
  INFORMATION_GREY: `${ICONS_SERVER_URL}/information-grey.svg`,
  INFORMATION_SOLID_BLACK: `${ICONS_SERVER_URL}/information-solid-black.svg`,
  INFORMATION_SOLID_WHITE: `${ICONS_SERVER_URL}/information-solid-white.svg`,
  LOGIN_BLACK: `${ICONS_SERVER_URL}/login-black.svg`,
  LOGIN_WHITE: `${ICONS_SERVER_URL}/login-white.svg`,
  MAIL_BLACK: `${ICONS_SERVER_URL}/mail-black.svg`,
  MAIL_WHITE: `${ICONS_SERVER_URL}/mail-white.svg`,
  MICROPHONE: `${ICONS_SERVER_URL}/microphone-music-talk.svg`,
  NOTIFICATION_BLACK: `${ICONS_SERVER_URL}/notification-black.svg`,
  NOTIFICATION_WHITE: `${ICONS_SERVER_URL}/notification-white.svg`,
  REFRESH_BLACK: `${ICONS_SERVER_URL}/refresh.svg`,
  SMARTPHONE_BLACK: `${ICONS_SERVER_URL}/smartphone-black.svg`,
  THIN_CHECKMARK_BLACK: `${ICONS_SERVER_URL}/checkmark-black.svg`,
  THIN_CHECKMARK_WHITE: `${ICONS_SERVER_URL}/checkmark-white.svg`,
  WARNING_ORANGE: `${ICONS_SERVER_URL}/warning-orange.svg`,
  ZOOM_IN: `${ICONS_SERVER_URL}/zoom-hover.svg`,
  FACET_AMBER: `${ICONS_SERVER_URL}/facet-amber.svg`,
  FACET_ROSE: `${ICONS_SERVER_URL}/facet-rose.svg`,
  FACET_RED: `${ICONS_SERVER_URL}/facet-red.svg`,
  FACET_BICOLOR: `${ICONS_SERVER_URL}/facet-bicolor-01.svg`,
  FACET_WHITE: `${ICONS_SERVER_URL}/facet-white.svg`,
  DELIVERY_CIRCLE: `${ICONS_SERVER_URL}/expe.svg`,
  LIST_VIEW_OUTLINED: `${ICONS_SERVER_URL}/list-outline-black.svg`,
  LIST_VIEW_FILLED: `${ICONS_SERVER_URL}/list-fill-black.svg`,
  GRID_VIEW_OUTLINED: `${ICONS_SERVER_URL}/grid-outline-black.svg`,
  GRID_VIEW_FILLED: `${ICONS_SERVER_URL}/grid-fill-black.svg`,

  // VIRTUAL SOMMELIER
  SPARKLES_STARS_WHITE: `${ICONS_SERVER_URL}/sparkle-stars-white.svg`,
  SPARKLES_STARS_PURPLE: `${ICONS_SERVER_URL}/sparkle-stars-purple.svg`,
  SEND_MESSAGE_WHITE: `${ICONS_SERVER_URL}/send-message-white.svg`,

  // GIF
  SOUND_WAVE: `${CDN_SERVER_URL}/next/sound_wave_16.gif`,

  // LOGOS
  LOGO_YOUSIGN: `${SVG_SERVER_URL}/logo-yousign.svg`,

  // IMAGES FROM S3
  NEWSLETTER_PUSH_IMAGE: `${COMMON_IMAGES}/push-newsletter.jpg`
};
